export default __webpack_public_path__ + "static/media/border-outer.bcd4fc7e.svg";